var safeHasOwnProperty = function safeHasOwnProperty(obj, prop) {
  return obj ? Object.prototype.hasOwnProperty.call(obj, prop) : false;
};
export default safeHasOwnProperty;